export default {
  api: {
    url: 'https://graphql.wnwd.com',
  },
  analytics: {
    mixpanelToken: '8d7dc1dbe1335a6de2e2cca5c8f28595',
  },
};
